import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { schema } from '@techstyle/redux-core';
import camelcaseKeys from 'camelcase-keys';
var emptyNullValues = new Set(['groupCode', 'maxProductQuantity', 'maxPurchaseUnitPrice', 'maxRequiredPurchaseUnitPrice', 'membershipPromoCurrentPeriodOnly', 'membershipPromoExpirationDays', 'membershipRewardMultiplier', 'requiredProductQuantity', 'timeEnd', 'timeStart']);
var booleanValues = new Set(['addProductAutomatically', 'exchangesAllowed', 'restrictCodeAccessToSpecificMemberships', 'rushShippingDiscountAllowed']);

function processInput(input, parent) {
  var output = {};

  for (var key in input) {
    var value = input[key];

    if (value === '' && (emptyNullValues.has(key) || key.endsWith('Id'))) {
      value = null;
    } else if (booleanValues.has(key)) {
      value = value === 1;
    } else {
      switch (key) {
        case 'dateEnd':
          // FIXME: This works around an API bug with `dateEnd` serialization.
          // Remove when API is fixed.
          if (value && typeof value === 'object') {
            value = value.date_end || null;
          }

          break;

        case 'discounts':
          value = value.map(discount => {
            var _camelcaseKeys = camelcaseKeys(discount),
                rate = _camelcaseKeys.rate,
                percentage = _camelcaseKeys.percentage,
                rest = _objectWithoutProperties(_camelcaseKeys, ["rate", "percentage"]);

            return _objectSpread(_objectSpread({}, rest), {}, {
              rate: rate === '' ? null : rate,
              percentage: percentage === '' ? null : percentage
            });
          });
          break;

        case 'statuscode':
          key = 'statusCode';
          break;

        case 'timeStart':
          if (value === '1970-01-01') {
            value = null;
          }

          break;
      }
    }

    output[key] = value;
  }

  return output;
}

export var Promos = new schema.Entity('Promos', {}, {
  idAttribute: 'promoId',
  processStrategy: processInput
});